import { Timestamp, where } from "firebase/firestore"

export interface LocationType {
  state?: string
  country?: string
  province?: string
  city?: string
}

export function getLocationQuery(location: LocationType, expirationDate = true) {
  const arr: any[] = [where("disabled", "==", false)]

  if (expirationDate) {
    arr.push(where("expirationDate", ">=", Timestamp.now().toMillis()))
  }

  if (location.country) {
    arr.push(where("location.country", "in", ["", "*", location.country]))
  }

  if (location.state) {
    arr.push(where("location.province", "in", ["", "*", location.state]))
  }

  if (location.city) {
    arr.push(where("location.city", "in", ["", "*", location.city]))
  }

  return arr
}
